import React from "react";
import PropTypes from "prop-types";
import { MuiThemeProvider } from "@material-ui/core";
import MaterialTable from "material-table";
import Scrollbars from "components/Scrollbars/Scrollbars";
import tableTheme from "components/UserAdminContent/TableTheme";

function OpportunitiesTableWrapper(props) {
    const {
        tableIcons,
        isLoading,
        columns,
        data,
        emptyMessage,
        detailPanel,
        className,
        ...rest
    } = props;
    return (
        <MuiThemeProvider theme={tableTheme}>
            <div className={`admin-table-wrapper ${className}`}>
                <Scrollbars>
                    <MaterialTable
                        localization={{
                            body: { emptyDataSourceMessage: <p>{emptyMessage}</p> },
                        }}
                        icons={tableIcons}
                        columns={columns}
                        data={data}

                        options={{
                            search: true,
                            paging: false,
                            sorting: true,
                            draggable: false,
                            filtering: false,
                            selection: false,
                            showTitle: false,
                            toolbar: false,
                        }}
                        detailPanel={detailPanel}
                        isLoading={isLoading}
                        {...rest}
                    />
                </Scrollbars>
            </div>
        </MuiThemeProvider>
    );
}

OpportunitiesTableWrapper.propTypes = {
    onModalClick: PropTypes.func.isRequired,
    className: PropTypes.string,
};

OpportunitiesTableWrapper.defaultProps = {
    emptyMessage: "No data.",
    detailPanel: undefined,
    className: ""
};

export default OpportunitiesTableWrapper;
